import { ExamStatsTab } from '../../../store/workspace/types';
import { ListItem } from '../../../store/general/types';

/** The nine soft-skill criteria the recruiting interview is scored against. */
export const RECRUITING_INTERVIEW_CRITERIA = [
    { key: 'culturalFit', title: 'Cultural Fit', head: ['Cultural', 'Fit'] },
    { key: 'communicationSkills', title: 'Communication Skills', head: ['Communication', 'Skills'] },
    { key: 'problemSolvingAbility', title: 'Problem-Solving Ability', head: ['Problem-Solving', 'Ability'] },
    { key: 'teamCollaboration', title: 'Team Collaboration', head: ['Team', 'Collaboration'] },
    { key: 'timeManagement', title: 'Time Management', head: ['Time', 'Management'] },
    { key: 'selfMotivation', title: 'Self Motivation', head: ['Self', 'Motivation'] },
    { key: 'multitaskingAbility', title: 'Multitasking Ability', head: ['Multitasking', 'Ability'] },
    { key: 'taskPrioritization', title: 'Task Prioritization', head: ['Task', 'Prioritization'] },
    { key: 'productivity', title: 'Productivity', head: ['Productivity'] },
] as const;

/** Multiple choice questions are always presented through these two filters. */
export const QUESTION_TYPE_FILTERS: ListItem[] = [
    { id: 'all', title: 'All' },
    { id: 'technical', title: 'Technical' },
    { id: 'general', title: 'General' },
    { id: 'coding', title: 'Coding' },
];

export const QUESTION_LEVEL_FILTERS: ListItem[] = [
    { id: 'all', title: 'All' },
    { id: 'easy', title: 'Easy' },
    { id: 'medium', title: 'Medium' },
    { id: 'hard', title: 'Hard' },
];

/** A coding exam always contains three questions. */
export const CODING_QUESTION_INDEXES = [0, 1, 2];

export interface ExamStatsTabItem {
    id: Exclude<ExamStatsTab, undefined>;
    title: string;
};

/** Tabs of the applicants list. Availability is resolved from the job info. */
export const EXAM_STATS_TABS: ExamStatsTabItem[] = [
    { id: 'overall', title: 'Overall results' },
    { id: 'recruitingInterview', title: 'Recruiting interview' },
    { id: 'multipleChoice', title: 'Multiple choice exam' },
    { id: 'coding', title: 'Coding exam' },
    { id: 'interview', title: 'Personal interview' },
    { id: 'finalResult', title: 'Final results' },
];

/** Tabs available on the exam sheet / exam result screens. */
export const EXAM_DETAIL_TABS: ExamStatsTabItem[] = [
    { id: 'recruitingInterview', title: 'Recruiting interview' },
    { id: 'multipleChoice', title: 'Multiple choice exam' },
    { id: 'coding', title: 'Coding exam' },
];

/** Column count used to size the loading skeleton of every tab. */
export const TAB_SKELETON_COLUMNS: Record<Exclude<ExamStatsTab, undefined>, number> = {
    overall: 6,
    recruitingInterview: 13,
    multipleChoice: 12,
    coding: 16,
    interview: 6,
    finalResult: 4,
};

export const JOBS_PAGE_SIZES = [25, 50];
